var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card" },
      [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-theme",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.openModal("pay_salary", "")
                    }
                  }
                },
                [_vm._v("Pagar salario")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-theme",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.openModal("anticipate_salary", "")
                    }
                  }
                },
                [_vm._v("Adelantar salario")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-check form-check-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.checkboxmanual,
                    expression: "checkboxmanual",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "inlineRadio5",
                  type: "radio",
                  name: "inlineRadioOptions",
                  value: "1"
                },
                domProps: { checked: _vm._q(_vm.checkboxmanual, "1") },
                on: {
                  change: [
                    function($event) {
                      _vm.checkboxmanual = "1"
                    },
                    function($event) {
                      return _vm.showSalaries(
                        1,
                        _vm.$route.query.item,
                        _vm.checkboxmanual
                      )
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "inlineRadio2" }
                },
                [_vm._v("Todos")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-check form-check-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checkboxmanual,
                    expression: "checkboxmanual"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "inlineRadio1",
                  type: "radio",
                  name: "inlineRadioOptions",
                  value: "2"
                },
                domProps: { checked: _vm._q(_vm.checkboxmanual, "2") },
                on: {
                  change: [
                    function($event) {
                      _vm.checkboxmanual = "2"
                    },
                    function($event) {
                      return _vm.showSalaries(
                        1,
                        _vm.$route.query.item,
                        _vm.checkboxmanual
                      )
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "inlineRadio1" }
                },
                [_vm._v("Pagados")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-check form-check-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checkboxmanual,
                    expression: "checkboxmanual"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "inlineRadio2",
                  type: "radio",
                  name: "inlineRadioOptions",
                  value: "3"
                },
                domProps: { checked: _vm._q(_vm.checkboxmanual, "3") },
                on: {
                  change: [
                    function($event) {
                      _vm.checkboxmanual = "3"
                    },
                    function($event) {
                      return _vm.showSalaries(
                        1,
                        _vm.$route.query.item,
                        _vm.checkboxmanual
                      )
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "inlineRadio2" }
                },
                [_vm._v("Sin pagar")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-check form-check-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.checkboxmanual,
                    expression: "checkboxmanual"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "inlineRadio3",
                  type: "radio",
                  name: "inlineRadioOptions",
                  value: "4"
                },
                domProps: { checked: _vm._q(_vm.checkboxmanual, "4") },
                on: {
                  change: [
                    function($event) {
                      _vm.checkboxmanual = "4"
                    },
                    function($event) {
                      return _vm.showSalaries(
                        1,
                        _vm.$route.query.item,
                        _vm.checkboxmanual
                      )
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "inlineRadio2" }
                },
                [_vm._v("Pagando")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-check form-check-inline" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.checkboxmanual,
                    expression: "checkboxmanual",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  id: "inlineRadio4",
                  type: "radio",
                  name: "inlineRadioOptions",
                  value: "5"
                },
                domProps: { checked: _vm._q(_vm.checkboxmanual, "5") },
                on: {
                  change: [
                    function($event) {
                      _vm.checkboxmanual = "5"
                    },
                    function($event) {
                      return _vm.showSalaries(
                        1,
                        _vm.$route.query.item,
                        _vm.checkboxmanual
                      )
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "inlineRadio2" }
                },
                [_vm._v("Anulados")]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("table", { staticClass: "table table-responsive table-hover" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.arraySalaries, function(salary) {
                return _c("tr", { key: salary.id }, [
                  _c("td", {
                    domProps: {
                      textContent: _vm._s(_vm.mymoney(salary.fortnight))
                    }
                  }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      textContent: _vm._s(_vm.mymoney(salary.discount_left))
                    }
                  }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      textContent: _vm._s(_vm.mymoney(salary.amount_dues))
                    }
                  }),
                  _vm._v(" "),
                  _c("td", { domProps: { textContent: _vm._s(salary.dues) } }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: {
                      textContent: _vm._s(_vm.showDate(salary.salary_date))
                    }
                  }),
                  _vm._v(" "),
                  _c("td", [
                    salary.state == 1
                      ? _c("span", { staticClass: "btn btn-success btn-sm" }, [
                          _vm._v("Pagado")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    salary.state == 2
                      ? _c(
                          "span",
                          { staticClass: "btn btn-secondary btn-sm" },
                          [_vm._v("Sin pagar")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    salary.state == 3
                      ? _c("span", { staticClass: "btn btn-warning btn-sm" }, [
                          _vm._v("Pagando")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    salary.state == 4
                      ? _c("span", { staticClass: "btn btn-danger btn-sm" }, [
                          _vm._v("Anulado")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      [
                        _c(
                          "div",
                          {
                            staticClass: "btn-group mr-2",
                            attrs: {
                              role: "group",
                              "aria-label": "First group"
                            }
                          },
                          [
                            salary.state == 2 || salary.state == 3
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: "Pagar adelanto",
                                        expression: "'Pagar adelanto'",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal(
                                          "pay_anticipate",
                                          salary
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-plus-circle"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top-center",
                                    value: "Ver pagos",
                                    expression: "'Ver pagos'",
                                    modifiers: { "top-center": true }
                                  }
                                ],
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.openModal(
                                      "watch_payments",
                                      salary
                                    )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                            ),
                            _vm._v(" "),
                            salary.state == 1 ||
                            salary.state == 2 ||
                            salary.state == 3
                              ? _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: "Anular",
                                        expression: "'Anular'",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-danger",
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal(
                                          "desactivate",
                                          salary
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-trash"
                                    })
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: "Convalidar",
                                        expression: "'Convalidar'",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-info",
                                    attrs: { href: "#" + salary.name },
                                    on: {
                                      click: function($event) {
                                        return _vm.openModal("activate", salary)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-check"
                                    })
                                  ]
                                )
                          ]
                        )
                      ]
                    ],
                    2
                  )
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "ul",
                { staticClass: "pagination pagination-primary m-b-0" },
                [
                  _vm.pagination.current_page > 1
                    ? _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.changePage(
                                  _vm.pagination.current_page - 1,
                                  _vm.checkboxmanual
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-angle-left"
                            })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.pagesNumber, function(page) {
                    return _c(
                      "li",
                      {
                        key: page,
                        staticClass: "page-item",
                        class: [page == _vm.isActived ? "active" : ""]
                      },
                      [
                        _c("a", {
                          staticClass: "page-link",
                          attrs: { href: "#" },
                          domProps: { textContent: _vm._s(page) },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.changePage(page, _vm.checkboxmanual)
                            }
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.pagination.current_page < _vm.pagination.last_page
                    ? _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.changePage(
                                  _vm.pagination.current_page + 1,
                                  _vm.checkboxmanual
                                )
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-angle-right"
                            })
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "salaries_modal",
            attrs: {
              title: _vm.modalTitle,
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c(
              "sweet-modal-tab",
              { attrs: { id: "tab1", title: "Datos del pago" } },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Cuenta")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-inline" },
                    [
                      _c("multiselect", {
                        class: { "is-invalid": _vm.$v.idaccount.$error },
                        attrs: {
                          options: _vm.accountArray,
                          "close-on-select": true,
                          "clear-on-select": false,
                          loading: _vm.isLoadingAccounts,
                          "show-labels": false,
                          label: "name",
                          "track-by": "id",
                          placeholder: "Buscar cuenta..."
                        },
                        on: {
                          input: _vm.cantidadAccount,
                          "search-change": _vm.selectAccount
                        },
                        model: {
                          value: _vm.idaccount,
                          callback: function($$v) {
                            _vm.idaccount = $$v
                          },
                          expression: "idaccount"
                        }
                      }),
                      _vm._v(" "),
                      _vm.$v.idaccount.$error
                        ? _c("div", [
                            !_vm.$v.idaccount.required
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "help-block help-block-error"
                                  },
                                  [_vm._v("La cuenta de retiro es requerida")]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Cantidad de la cuenta")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.amountAccount,
                        expression: "amountAccount"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: "" },
                    domProps: { value: _vm.amountAccount },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.amountAccount = $event.target.value
                        },
                        function($event) {
                          return _vm.$v.amountAccount.$touch()
                        }
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Tipo de pago")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.paymentAccount,
                          expression: "paymentAccount",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.$v.paymentAccount.$error },
                      on: {
                        input: function($event) {
                          return _vm.$v.paymentAccount.$touch()
                        },
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.paymentAccount = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.arrayAccountPayments, function(paymentAccount) {
                      return _c("option", {
                        key: paymentAccount.id,
                        domProps: {
                          value: paymentAccount.id,
                          textContent: _vm._s(paymentAccount.name)
                        }
                      })
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.$v.paymentAccount.$error
                    ? _c("div", [
                        !_vm.$v.paymentAccount.required
                          ? _c(
                              "span",
                              { staticClass: "help-block help-block-error" },
                              [_vm._v("El tipo de pago es requerido")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Quíncena")]),
                    _vm._v(" "),
                    _c("masked-input", {
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.$v.fortnight.$error },
                      attrs: {
                        mask: _vm.mask_quetzal,
                        guide: false,
                        "keep-char-positions": true,
                        "show-mask": true,
                        type: "text",
                        placeholder: "Ingrese el sueldo quincenal"
                      },
                      on: {
                        input: function($event) {
                          return _vm.$v.fortnight.$touch()
                        }
                      },
                      model: {
                        value: _vm.fortnight,
                        callback: function($$v) {
                          _vm.fortnight =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "fortnight"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.fortnight.$error
                      ? _c("div", [
                          !_vm.$v.fortnight.required
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("El campo es requerido")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.fortnight.min &&
                          parseFloat(_vm.converMaskToNumber(_vm.fortnight)) ==
                            0.0
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("El valor no puede ser cero")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.fortnight.max &&
                          parseFloat(_vm.converMaskToNumber(_vm.fortnight)) >
                            parseFloat(
                              _vm.converMaskToNumber(_vm.amountAccount)
                            )
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [
                                  _vm._v(
                                    "La cantidad de la quíncena no puede ser superior a la de la cuenta"
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Fecha del pago")]),
                    _vm._v(" "),
                    _c("datepicker", {
                      class: { "is-invalid": _vm.$v.salary_date.$error },
                      attrs: {
                        format: _vm.customFormatter,
                        language: _vm.es,
                        "input-class": "form-control",
                        placeholder: "Ingrese la fecha de pago de la quíncena"
                      },
                      on: {
                        input: function($event) {
                          return _vm.$v.salary_date.$touch()
                        }
                      },
                      model: {
                        value: _vm.salary_date,
                        callback: function($$v) {
                          _vm.salary_date =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "salary_date"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.salary_date.$error
                      ? _c("div", [
                          !_vm.$v.salary_date.required
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("La fecha del pago es requerida")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("sweet-modal-tab", { attrs: { id: "tab2", title: "Faltas" } }, [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "table table-responsive table-sm" }, [
                  _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Descripción")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Fecha")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.arrayFaults, function(fault) {
                        return _c("tr", { key: fault.id }, [
                          _c("td", {
                            domProps: { textContent: _vm._s(fault.description) }
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.showDate(fault.fault_date)
                              )
                            }
                          })
                        ])
                      }),
                      0
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cancelar")]
            ),
            _vm._v(" "),
            _vm.tipoAccion == 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveSalary()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Guardar")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "anticipate_salary",
            attrs: {
              title: _vm.modalTitle,
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c(
              "sweet-modal-tab",
              { attrs: { id: "tab1", title: "Datos del adelanto" } },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Cuenta")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-inline" },
                    [
                      _c("multiselect", {
                        class: { "is-invalid": _vm.$v.idaccount.$error },
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: _vm.accountArray,
                          "close-on-select": true,
                          "clear-on-select": false,
                          loading: _vm.isLoadingAccounts,
                          label: "name",
                          "track-by": "id",
                          placeholder: "Buscar Cuenta..."
                        },
                        on: {
                          input: _vm.cantidadAccount,
                          "search-change": _vm.selectAccount
                        },
                        model: {
                          value: _vm.idaccount,
                          callback: function($$v) {
                            _vm.idaccount = $$v
                          },
                          expression: "idaccount"
                        }
                      }),
                      _vm._v(" "),
                      _vm.$v.idaccount.$error
                        ? _c("div", [
                            !_vm.$v.idaccount.required
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "help-block help-block-error"
                                  },
                                  [_vm._v("La cuenta de retiro es requerida")]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Cantidad de la cuenta")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.amountAccount,
                        expression: "amountAccount"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: "" },
                    domProps: { value: _vm.amountAccount },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.amountAccount = $event.target.value
                        },
                        function($event) {
                          return _vm.$v.amountAccount.$touch()
                        }
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Tipo de pago")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.paymentAccount,
                          expression: "paymentAccount",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.$v.paymentAccount.$error },
                      on: {
                        input: function($event) {
                          return _vm.$v.paymentAccount.$touch()
                        },
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.paymentAccount = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.arrayAccountPayments, function(paymentAccount) {
                      return _c("option", {
                        key: paymentAccount.id,
                        domProps: {
                          value: paymentAccount.id,
                          textContent: _vm._s(paymentAccount.name)
                        }
                      })
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.$v.paymentAccount.$error
                    ? _c("div", [
                        !_vm.$v.paymentAccount.required
                          ? _c(
                              "span",
                              { staticClass: "help-block help-block-error" },
                              [_vm._v("El tipo de pago es requerido")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Quíncena adelantada")]),
                    _vm._v(" "),
                    _c("masked-input", {
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.$v.fortnight.$error },
                      attrs: {
                        mask: _vm.mask_quetzal,
                        guide: false,
                        "keep-char-positions": true,
                        "show-mask": true,
                        type: "text",
                        placeholder: "Ingrese el sueldo quincenal a adelantar"
                      },
                      on: {
                        input: function($event) {
                          return _vm.$v.fortnight.$touch()
                        }
                      },
                      model: {
                        value: _vm.fortnight,
                        callback: function($$v) {
                          _vm.fortnight =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "fortnight"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.fortnight.$error
                      ? _c("div", [
                          !_vm.$v.fortnight.required
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("El campo es requerido")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.fortnight.min &&
                          parseFloat(_vm.converMaskToNumber(_vm.fortnight)) ==
                            0.0
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("El valor no puede ser cero")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.fortnight.max &&
                          parseFloat(_vm.converMaskToNumber(_vm.fortnight)) >
                            parseFloat(
                              _vm.converMaskToNumber(_vm.amountAccount)
                            )
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [
                                  _vm._v(
                                    "La cantidad de la quíncena no puede ser superior a la de la cuenta"
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Cantidad de pagos")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.dues,
                        expression: "dues",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.$v.dues.$error },
                    attrs: { placeholder: "Ingrese la cantidad de pagos" },
                    domProps: { value: _vm.dues },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.dues = $event.target.value.trim()
                        },
                        function($event) {
                          return _vm.duesFunction()
                        }
                      ],
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.$v.dues.$error
                    ? _c("div", [
                        !_vm.$v.dues.required
                          ? _c(
                              "span",
                              { staticClass: "help-block help-block-error" },
                              [_vm._v("El campo es requerido")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Descuento por salario")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.amount_dues,
                        expression: "amount_dues",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { readonly: "" },
                    domProps: { value: _vm.amount_dues },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.amount_dues = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Fecha del adelanto")]),
                    _vm._v(" "),
                    _c("datepicker", {
                      class: { "is-invalid": _vm.$v.salary_date.$error },
                      attrs: {
                        format: _vm.customFormatter,
                        language: _vm.es,
                        "input-class": "form-control",
                        placeholder: "Seleccione la fecha del adelanto"
                      },
                      model: {
                        value: _vm.salary_date,
                        callback: function($$v) {
                          _vm.salary_date =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "salary_date"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.salary_date.$error
                      ? _c("div", [
                          !_vm.$v.salary_date.required
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("La fecha del adelanto es requerida")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("sweet-modal-tab", { attrs: { id: "tab2", title: "Faltas" } }, [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "table table-responsive table-sm" }, [
                  _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Descripción")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Fecha")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.arrayFaults, function(fault) {
                        return _c("tr", { key: fault.id }, [
                          _c("td", {
                            domProps: { textContent: _vm._s(fault.description) }
                          }),
                          _vm._v(" "),
                          _c("td", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.showDate(fault.fault_date)
                              )
                            }
                          })
                        ])
                      }),
                      0
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cancelar")]
            ),
            _vm._v(" "),
            _vm.tipoAccion == 2
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveSalary()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Guardar")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "pay_anticipate",
            attrs: {
              title: _vm.modalTitle,
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Cantidad restante")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.discount_left,
                        expression: "discount_left",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { readonly: "" },
                    domProps: { value: _vm.discount_left },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.discount_left = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Cantidad por pago")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.amount_dues,
                        expression: "amount_dues",
                        modifiers: { trim: true }
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { readonly: "" },
                    domProps: { value: _vm.amount_dues },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.amount_dues = $event.target.value.trim()
                      },
                      blur: function($event) {
                        return _vm.$forceUpdate()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Cantidad a pagar")]),
                    _vm._v(" "),
                    _c("masked-input", {
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.$v.amount.$error },
                      attrs: {
                        mask: _vm.mask_quetzal,
                        guide: false,
                        "keep-char-positions": true,
                        "show-mask": true,
                        type: "text",
                        placeholder: "Ingrese la cantidad a pagar"
                      },
                      on: {
                        input: function($event) {
                          return _vm.$v.amount.$touch()
                        }
                      },
                      model: {
                        value: _vm.amount,
                        callback: function($$v) {
                          _vm.amount =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "amount"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.amount.$error
                      ? _c("div", [
                          !_vm.$v.amount.required
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("El campo es requerido")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.amount.min &&
                          parseFloat(_vm.converMaskToNumber(_vm.amount)) === 0
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("El valor no puede ser cero")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.$v.amount.max &&
                          parseFloat(_vm.converMaskToNumber(_vm.amount)) >
                            parseFloat(
                              _vm.converMaskToNumber(_vm.discount_left)
                            )
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [
                                  _vm._v(
                                    "La cantidad del pago no puede ser superior al adelanto restante"
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Fecha del pago")]),
                    _vm._v(" "),
                    _c("datepicker", {
                      class: { "is-invalid": _vm.$v.payment_date.$error },
                      attrs: {
                        format: _vm.customFormatter,
                        language: _vm.es,
                        "input-class": "form-control",
                        placeholder: "Ingrese la fecha del pago"
                      },
                      on: {
                        input: function($event) {
                          return _vm.$v.payment_date.$touch()
                        }
                      },
                      model: {
                        value: _vm.payment_date,
                        callback: function($$v) {
                          _vm.payment_date =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "payment_date"
                      }
                    }),
                    _vm._v(" "),
                    _vm.$v.payment_date.$error
                      ? _c("div", [
                          !_vm.$v.payment_date.required
                            ? _c(
                                "span",
                                { staticClass: "help-block help-block-error" },
                                [_vm._v("La fecha del pago es requerida")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cancelar")]
            ),
            _vm._v(" "),
            _vm.tipoAccion == 3
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary ladda-button",
                    attrs: {
                      slot: "button",
                      type: "button",
                      "data-style": "expand-right"
                    },
                    on: {
                      click: function($event) {
                        return _vm.savePayment()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Guardar pago")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "watch_payments",
            attrs: {
              title: _vm.modalTitle,
              "hide-close-button": "",
              blocking: ""
            }
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "table table-responsive table-sm" }, [
                _c("table", { staticClass: "table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Cantidad pagada")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Fecha")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.arrayPayments, function(payment) {
                      return _c("tr", { key: payment.id }, [
                        _c("td", {
                          domProps: {
                            textContent: _vm._s(_vm.mymoney(payment.amount))
                          }
                        }),
                        _vm._v(" "),
                        _c("td", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.showDate(payment.payment_date)
                            )
                          }
                        })
                      ])
                    }),
                    0
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cerrar")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "state_modal",
            attrs: { icon: "info", "hide-close-button": "", blocking: "" }
          },
          [
            _vm._v("\n      " + _vm._s(_vm.modalTitleState) + "\n      "),
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$refs.state_modal.close()
                  }
                },
                slot: "button"
              },
              [_vm._v("No")]
            ),
            _vm._v(" "),
            _vm.tipoAccion == 4
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { slot: "button", type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.desactivateSalary()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Si")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.tipoAccion == 5
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { slot: "button", type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.activateSalary()
                      }
                    },
                    slot: "button"
                  },
                  [_vm._v("Si")]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "sweet-modal",
          {
            ref: "no_salaries",
            attrs: { icon: "info", "hide-close-button": "", blocking: "" }
          },
          [
            _vm._v(
              "\n      " + _vm._s("Este salario no contiene pagos") + "\n      "
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { slot: "button", type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                },
                slot: "button"
              },
              [_vm._v("Cerrar")]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Salarios")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "/" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Empleado")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v("Salarios")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Salario")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad Restante")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad por pagos")]),
        _vm._v(" "),
        _c("th", [_vm._v("Pagos pendientes")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de pago")]),
        _vm._v(" "),
        _c("th", [_vm._v("Estado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af4fd7cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af4fd7cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/persons/Salary.vue
// module id = 690
// module chunks = 0